import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    rootDialog: {
        borderRadius: 0,
        borderTopLeftRadius: '1.875rem',
        borderBottomRightRadius: '1.875rem',
        backgroundColor: 'rgb(38, 54, 68)',
    },
    dialogTitleContainer: {
        padding: '1.875rem 3.75rem',
    },
    dialogTitle: {
        fontSize: '1.875rem',
        fontWeight: 'bold',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(5),
        top: theme.spacing(3),
    },
    closeButtonIcon: {
        width: '2.813rem',
        height: '2.813rem',
        color: 'black',
    },
    dialogContentContainer: {
        padding: '0px 3.75rem',
        border: 0,
    },
    paperContainer: {
        borderRadius: 0,
        backgroundColor: '#F5F5F5',
        padding: '1.25rem 1.875rem',
        margin: '0.938rem 0px',
    },
    paperContainerDateField: {
        width: '90%',
    },
    inputLabel: {
        fontSize: '1.25rem',
        fontWeight: 600,
    },
    inputText: {
        fontSize: '1rem',
        fontWeight: 400,
    },
    addTaskButton: {
        margin: '1.25rem 3.75rem',
        padding: '1.563rem 1.875rem',
    },
    addTaskButtonLabel: {
        fontSize: '1.375rem',
    },
    smallerRightMargin: {
        marginRight: '0.625rem',
    },
    calendarIcon: {
        color: 'black',
        width: '1.875rem',
        height: '1.875rem',
    },
    textFieldWrapper: {},
    textField: {
        width: '100%',
        '& textarea': {
            '&::-webkit-scrollbar': {
                width: '0.597rem',
                margin: '0px 0.625rem',
                color: 'white',
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: '#E2E2E2',
                border: 'solid 3px transparent',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'white',
                maxHeight: 50,
                outline: '1px solid white',
            },
        },
    },
    rootSelect: {
        padding: 0,
        fontSize: '1rem',
        fontWeight: 400,
        paddingLeft: '0px!important',
        '&:focus': {
            padding: 0,
            paddingLeft: 0,
        },
    },
    selectedItem: {
        padding: 0,
        paddingLeft: '0px!important',
        fontSize: '1rem',
        fontWeight: 400,
    },
}));
